
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"1.999","height":"10","rx":".999","transform":"matrix(.7071 -.7071 -.7121 -.70208 8.028 13.052)","fill":"#2A3C46"}}),_c('path',{attrs:{"d":"M7.33 10.932a.992.992 0 00-.005 1.409c.39.39 1.026.393 1.42.005l5.696-5.617a.991.991 0 00.005-1.409 1.009 1.009 0 00-1.419-.005L7.33 10.932z","fill":"#2A3C46"}})])
          )
        }
      }
    